import { createFileRoute } from "@tanstack/react-router";
import AdminSetModuleNewPage from "@/pages/admin/sets/detail/modules/new";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/modules/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms } = useSetsPermissions();

  return (
    <AdminSetModuleNewPage
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
    />
  );
}
